<template>
  <div>
    <AdmissionsAdmin v-if="checkAdmin()" />
    <AdmissionsUser v-else />
  </div>
</template>

<script>
import AdmissionsAdmin from "@/views/marketingAdmin/technicalDialogue/admissionsAdmin.vue";
import AdmissionsUser from "@/views/marketingAdmin/technicalDialogue/admissionsUser.vue";
export default {
  name: "TechnicalDialogue",
  components: { AdmissionsAdmin, AdmissionsUser },
};
</script>